import React, { useState } from 'react'
import { popCancelBttn, resetIcon, expandAppliedFilterMobile } from '../../assets';
import './ContentShortcutFilterDisplay.css';

const formattedStringArr = (array, fn) => {
    var result = [];
    for (var i = 0; i < array.length; i++) {
        var mapping = fn(array[i].replaceAll('☼', '|'));
        if (i === array.length - 1) {
            result = result.concat(array[i].replaceAll('☼', '|'));
        }
        else {
            result = result.concat(mapping);
        }
    }
    return result;
}
const divider = () => {
    return (
        <span className="subfilter-divider"></span>
    )
}
const renderSubFilters = (facet, handleRemoveAppliedFilter) => (subFilter, key) => <>
    <span key={key} className="subfilter">
        <span className="subfilter-text" title={subFilter}>{formattedStringArr(subFilter.replaceAll('|', '☼').replaceAll('/', '|').split('|'), function (part) {
            return [part, <span>{divider()}</span>];
        })}</span>
        <img src={popCancelBttn} alt='' className='remove-filter clickable' title={`Remove ${subFilter}`} onClick={() => { handleRemoveAppliedFilter(facet + '/' + subFilter) }} />
    </span>
</>
export default function ContentShortcutFilterDisplay(props) {
    const [showFilters, setShow] = useState(false);
    const {
        appliedFilters,
        handleClearFilters,
        handleRemoveAppliedFilter,
        customWidth
    } = props;

    //const service = new FilterService()
    //const reducedFilters = service.condenseFilterSet(allFilters,appliedFilters)
    const displayFilters = {}
    appliedFilters.forEach(filter => {
        const filterParts = filter.split('/')
        const filterTop = filterParts.shift()
        displayFilters[filterTop] = displayFilters[filterTop] || []
        displayFilters[filterTop].push(filterParts.join('/'))
    })
    //console.log(reducedFilters)
    //console.log(displayFilters)
    if (customWidth <= 600) {
        return (
            <div className="filter-selection-display-wrapper-mobile">
                <div className="applied-filter-header-section-mobile">
                    <div className="applied-filter-header-text-mobile">Applied Filters</div>
                    <div className="applied-filters-header-icons-wrapper">
                        <div onClick={e => setShow(!showFilters)}>
                            {!showFilters ?
                                <img src={expandAppliedFilterMobile} alt="" width="22" height="22" />
                                :
                                <img src={expandAppliedFilterMobile} alt="" width="22" height="22" style={{ transform: "rotate(180deg)" }} />
                            }

                        </div>
                        <div
                            onClick={e => handleClearFilters()}
                            className="clear-all-button-mobile" title="Remove All Filters">
                            <img src={resetIcon} alt="" style={{ paddingBottom: "3%" }} />
                        </div>
                        {/* <div onClick={e=>handleClearFilters()}>
                    <img src={cancelRedIcon} alt="" width="22" height="22"/>
                </div> */}
                    </div>
                </div>
                {showFilters &&
                    <div className="filter-display-item-wrapper filter-display-item-wrapper-mobile">
                        {Object.entries(displayFilters).map(([facet, refiners], index) =>
                            <div key={index} className="facet-item-wrapper">
                                <span className="facet-inner-wrapper">
                                    {facet === 'Recently Added_Updated' ?
                                        <span className="parentFilter parentFilter-mobile">Recently Added/Updated</span> :
                                        facet === 'Document Subtypes' ?
                                            <span className="parentFilter parentFilter-mobile">{facet} (Submission-Related Documents Only)</span> :
                                            <span className="parentFilter parentFilter-mobile">{facet}</span>}
                                    <span className='subfilter-wrapper'>
                                        {refiners
                                            .map(renderSubFilters(facet, handleRemoveAppliedFilter))
                                            .reduce((elements, element) =>
                                                elements === undefined
                                                    ? element
                                                    : <>{elements}<span className='filter-divider'></span>{element}</>
                                            )
                                        }
                                    </span>
                                </span>
                            </div>
                        )}
                    </div>
                }
            </div>
        )
    }
    else {
        return (
            <div className="filter-selection-display-wrapper">
                <div className="applied-filter-header-section">
                    <span className="cs-applied-filter-header-text">Applied Filters</span>
                    <span className="cs-filter-display-remove-button-wrapper">
                        <button
                            onClick={handleClearFilters}
                            className="cs-clear-all-button" title="Remove All Filters">
                            Reset Selection &nbsp;
                            <svg xmlns="http://www.w3.org/2000/svg" style={{ paddingBottom: "2%" }} width="11.724" height="13.727" viewBox="0 0 11.724 13.727">
                                <g id="ic_forward_30_24px" transform="translate(0.25 0.57)">
                                    <path id="ic_forward_30_24px-2" data-name="ic_forward_30_24px" d="M4,8.744a5.417,5.417,0,0,0,5.612,5.163,5.417,5.417,0,0,0,5.612-5.163h-1.4a4.063,4.063,0,0,1-4.209,3.872A4.063,4.063,0,0,1,5.4,8.744,4.063,4.063,0,0,1,9.612,4.872V7.454l3.507-3.227L9.612,1V3.581A5.417,5.417,0,0,0,4,8.744Z" transform="translate(-4 -1)" fill="#EB1700" stroke="#EB1700" stroke-width="0.5" />
                                </g>
                            </svg>
                        </button>
                    </span>
                </div>
                <div className="filter-display-item-wrapper">
                    {Object.entries(displayFilters).map(([facet, refiners], index) =>
                        <div key={index} className="facet-item-wrapper">
                            <span className="facet-inner-wrapper">
                                {facet === 'Recently Added_Updated' ?
                                    <span className="gen-ai-result-fs-parent-field-wrapper">Recently Added/Updated</span> :
                                    facet === 'Document Subtypes' ?
                                        <span className="gen-ai-result-fs-parent-field-wrapper">{facet} (Submission-Related Documents Only)</span> :
                                        <span className="gen-ai-result-fs-parent-field-wrapper">{facet}</span>}
                                <span className='subfilter-wrapper'>
                                    {refiners
                                        .map(renderSubFilters(facet, handleRemoveAppliedFilter))
                                        .reduce((elements, element) =>
                                            elements === undefined
                                                ? element
                                                : <>{elements}<span className='filter-divider'></span>{element}</>
                                        )
                                    }
                                </span>
                            </span>
                        </div>
                    )}
                </div>
            </div>
        )
    }
};